"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CError = exports.CERROR_SYMBOL = void 0;
exports.CERROR_SYMBOL = Symbol.for('contextual-error/cerror');
class CError extends Error {
    name = 'CError';
    info = {};
    /**
     * For debugging, we keep track of the original short message (attached
     * to this Error particularly) separately from the complete message,
     * which includes the messages of our cause chain.
     */
    shortMessage;
    constructor(message, options) {
        super(message, { cause: options?.cause });
        Object.defineProperty(this, exports.CERROR_SYMBOL, { value: true });
        this.shortMessage = this.message;
        if (options?.info) {
            /*
                * If we've been given an object with properties, shallow-copy that
                * here.  We don't want to use a deep copy in case there are non-plain
                * objects here, but we don't want to use the original object in case
                * the caller modifies it later.
                */
            for (const k in options.info) {
                this.info[k] = options.info[k];
            }
        }
        if (options?.name) {
            this.name = options.name;
        }
        if (options?.cause) {
            if (!options.skipCauseMessage && typeof options.cause?.message === 'string') {
                this.message += `: ${options.cause.message}`;
            }
        }
        /* istanbul ignore else */
        if (Error.captureStackTrace) {
            const ctor = options?.constructorOpt || this.constructor;
            Error.captureStackTrace(this, ctor);
        }
    }
    toString() {
        let str = this.name;
        /* istanbul ignore else */
        if (this.message) {
            str += ': ' + this.message;
        }
        return str;
    }
    toJSON() {
        return {
            error: this.name,
            message: this.shortMessage,
        };
    }
    static isCError(obj) {
        return obj?.[exports.CERROR_SYMBOL] != null;
    }
    static getCause(err) {
        if (err.cause) {
            return err.cause;
        }
        else {
            return null;
        }
    }
    static info(err) {
        const cause = CError.getCause(err);
        let info;
        if (cause !== null) {
            info = CError.info(cause);
        }
        else {
            info = {};
        }
        // Sorta messy duck-type check of err.info for info object merging
        if (typeof (err.info) == 'object' && err.info !== null) {
            for (const k in err.info) {
                info[k] = err.info[k];
            }
        }
        return info;
    }
    /**
     * Returns a string containing the full stack trace, with all nested errors recursively reported as 'caused by:' + err.stack.
     */
    static fullStack(err) {
        const cause = CError.getCause(err);
        if (cause) {
            return (err.stack + '\ncaused by: ' + CError.fullStack(cause));
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return err.stack;
    }
    static findCauseByName(err, name) {
        let cause;
        for (cause = err; cause !== null; cause = CError.getCause(cause)) {
            if (cause.name == name) {
                return cause;
            }
        }
        return null;
    }
    static hasCauseWithName(err, name) {
        return CError.findCauseByName(err, name) !== null;
    }
}
exports.CError = CError;
exports.default = CError;
//# sourceMappingURL=data:application/json;base64,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